'use strict';

(function () {
    'use strict';

    angular.module('insurerContracts', ['ui.router', 'common']);
})();